module.exports = __webpack_public_path__ + "img/czapki-z-daszkiem.336434d9.jpeg";